import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { theme, buttonClass } from '../ui/theme';

const NoticeDetail = ({ noticeId, onClose }) => {
  const { i18n } = useTranslation();
  const [noticeDoc, setNoticeDoc] = useState(null);
  const [notice, setNotice] = useState(null);
  const [mhtmlUrl, setMhtmlUrl] = useState(null);

  useEffect(() => {
    if (noticeId) {
      axios.get(`/api/notices/${noticeId}`)
        .then(res => {
          setNoticeDoc(res.data);
          const trans = res.data.translations?.[i18n.language] || res.data.translations?.en || null;
          setNotice(trans);
          const atts = Array.isArray(res.data.attachments) ? res.data.attachments : [];
          const m = atts.find(a => /\.(mhtml|mht)$/i.test(a.name || a.url));
          setMhtmlUrl(m ? m.url : null);
        });
    }
  }, [noticeId, i18n.language]);

  if (!noticeId || !notice) return null;

  const attachments = Array.isArray(noticeDoc?.attachments) ? noticeDoc.attachments : [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 overflow-auto">
      <div className={[theme.surfaces.modalPanel, 'rounded-lg shadow-lg max-w-3xl w-full p-6 relative max-h-[90vh] overflow-y-auto text-white'].join(' ')}>
        <button className={['absolute top-2 right-2', buttonClass({ variant: 'ghost', size: 'xs' })].join(' ')} onClick={onClose}>✕</button>
        <h2 className="text-xl font-semibold mb-4">{notice.title}</h2>

        {/* 若存在 mhtml 附件，内联嵌入显示 */}
        {mhtmlUrl ? (
          <div className="mb-4 border border-white/10 rounded overflow-hidden bg-black/20" style={{height: '70vh'}}>
            <iframe title="mhtml-preview" src={mhtmlUrl} style={{width: '100%', height: '100%', border: '0'}} />
          </div>
        ) : (
          <div className="ck-content prose max-w-none mb-4" style={{wordBreak: 'break-all', overflowX: 'auto'}} dangerouslySetInnerHTML={{ __html: notice.content }} />
        )}

        {/* 附件列表 */}
        {attachments.length > 0 && (
          <div className="mt-4">
            <div className="font-semibold mb-2">附件：</div>
            <ul className="list-disc pl-5 space-y-1">
              {attachments.map((att, idx) => (
                <li key={idx}>
                  <a href={att.url} target="_blank" rel="noopener noreferrer" className={theme.links.subtleUnderline}>{att.name || att.url}</a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoticeDetail; 